export const SET_CONTACT_DETAILS = 'SET_CONTACT_DETAILS';
